import { render, staticRenderFns } from "./ContactUsMenu.vue?vue&type=template&id=19a53925"
import script from "./ContactUsMenu.vue?vue&type=script&lang=js"
export * from "./ContactUsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports